import React from 'react'
import Modal from 'components/modal'
import Button from 'components/controls/button'
import { inject } from 'shared/helpers/functional'
import 'less/preview-conference-link-modal.less'
import ExampleEmail from 'components/ExampleEmail'
const PreviewConferenceLink = props => {
 
  let values = {
    meetingInformation: '<span style="color: #000000; text-decoration: none;">${meetingInformation}</span>',
    meetingLink: '${meetingLink}',
    topicName: props.topicName.get(props.code) ? props.topicName.get(props.code) : '${topicName}',
    meetingMinutes: props.meetingMinutes,
    salesforceJobNumber:props.salesforceJobNumber,
    firstName: '${firstName}',
    honorarium: '${honorarium}',
    startTime: '${startTime}',
    CurrencyText: '${CurrencyText}',
    shgProjectNumber: '${shgProjectNumber}'
  };

  
  let emailWithInjectedValues = props.exampleEmail && { __html: inject(props.exampleEmail.__html, values) } 
  const responderLangugae =  props.responderLanguage ? props.responderLanguage.substring(0, props.responderLanguage.indexOf(' ')) : '' 
  let title="Preview Conference Link" + ' ' +'('+ responderLangugae + ')'

  return (
    <Modal
      isOpen={props.isOpen}
      className="preview-conference-link"
      type="modal"
      title={title}
      onCancel={()=>props.onCancel()}
     
      showSubmitBtn={false}
      cancelBtnText = "Close"
    >
      
      {props.exampleEmail  &&    <div className="example-email">  <ExampleEmail
              exampleEmail={emailWithInjectedValues}
            /></div>}
    </Modal>
  )
}

export default PreviewConferenceLink
